export enum ReplyStatus {
    All,
    Missing,
    Replied,
}
